export class LAInput {
  public topologyId: string;
  public startDate: string;
  public endDate: string;
  public useCableOGM : boolean;
  public useTrafoOGM : boolean;
}
